import React, { useEffect, useState } from "react";
import MyDiv from "./jobSkills.style";
import {
    Box, Flex, Grid, GridItem, Image, Input, InputGroup, InputLeftElement, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter, FormControl, Button, Center, Spinner, Tag, TagCloseButton, TagLabel,
} from "@chakra-ui/react";
import { ActionEditIcon, CustomButton, CustomTable, CustomToast, } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";
import { Search2Icon } from "@chakra-ui/icons";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { emptyJobSkills, IJobSkills, schema } from "./modal";
import { IJobProfile } from "../JobProfile/Model";
import PlusIcon from "../../../../../assets/images/Vector.svg"
import { Dropdown } from "../../../../../components/DropDown/DropDown";
import { Column } from "../../../../../components/CustomTable/customTable";

const JobSkills = () => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [skills, setSkills] = useState<any[]>([]);
    const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
    const [jobProfileOptions, setJobProfileOptions] = useState<any[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [chips, setChips] = useState<string[]>([]);

    const { handleSubmit, control, formState: { errors }, reset, watch, setValue } = useForm<IJobSkills>({
        resolver: yupResolver(schema),
        defaultValues: emptyJobSkills,
        mode: "onBlur",
    });

    const Header = [
        { id: 1, head: "S. No" },
        { id: 2, head: "Department" },
        { id: 3, head: "Job Profile" },
        { id: 4, head: "Skills" },
        { id: 5, head: "Actions" },
    ];

    const handleAddNewJobSkills = () => {
        setIsEditMode(false);
        reset(emptyJobSkills);
        setDrawerOpen(true);
    };

    const handleEditJobProfile = async (jobSkills: any) => {
        setIsEditMode(true);
        reset({
            id: jobSkills.id ?? undefined,
            department_Id: jobSkills.department_Id,
            job_Profile_Id: jobSkills.job_Profile_Id,
            skills: jobSkills.skills || []
        });

        // Preload job profiles for this department so dropdown shows correct options
        await loadJobProfile(jobSkills.department_Id);

        // Sync chips with skills
        setChips(jobSkills.skills || []);

        setDrawerOpen(true);
    };


    const onSubmit = async (data: IJobSkills) => {
        let payload: IJobSkills = {
            id: data.id,
            department_Id: data.department_Id,
            job_Profile_Id: data.job_Profile_Id,
            skills: data.skills,
        };

        const method = isEditMode && data.id ? "PUT" : "POST";

        const response = await fetchApi("RecruitmentMaster/JobSkills", method, payload, "", "Job skills added successfully");
        if (response) {
            setDrawerOpen(false);
            loadJobSkills();
            reset(emptyJobSkills);
            setChips([]);
            setInputValue("");
        }
    };

    const loadDepartmentOptions = async () => {
        const res = await fetchApi("DropDown/department", "GET", null, "", "");
        if (res) setDepartmentOptions(res);
    };

    const loadJobProfile = async (department_Id?: number) => {
        const res = await fetchApi("DropDown/getJobProfile", "GET", null, `department_Id=${department_Id}`, "");
        if (res) setJobProfileOptions(res);
    };

    const handleKeyDown = (e: any) => {
        if (e.key === "Enter" && inputValue.trim() !== "") {
            e.preventDefault();
            if (!chips.includes(inputValue.trim())) {
                const newChips = [...chips, inputValue.trim()];
                setChips(newChips);
                setValue("skills", newChips, { shouldValidate: true }); // ✅ update form value
            }
            setInputValue("");
        }
    };

    const handleRemoveChip = (chipToRemove: string) => {
        const newChips = chips.filter((chip) => chip !== chipToRemove);
        setChips(newChips);
        setValue("skills", newChips, { shouldValidate: true }); // ✅ update form value
    };


    useEffect(() => {
        loadDepartmentOptions();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (name === "department_Id") {
                loadJobProfile(value.department_Id ? Number(value.department_Id) : 0);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const loadJobSkills = async () => {
        const res = await fetchApi("RecruitmentMaster/JobSkills", "GET", null, "", "");
        if (res) setSkills(res);
    };

    useEffect(() => {
        loadJobSkills();
    }, []);

    const closeDrawer = () => {
        setDrawerOpen(false);
        reset(emptyJobSkills);
        setChips([]);
        setInputValue("");
    }

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {/* {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>
                ) : */}
                <>
                    <Flex className="page_heading flex_header">
                        <Text className="font-poppins text_semibold text_3xl">
                            Job Skills
                        </Text>
                        <Flex gap={2}>
                            <InputGroup width="197px" height="37px">
                                <InputLeftElement pointerEvents="none">
                                    <Search2Icon color="rgba(102, 112, 133, 1)" />
                                </InputLeftElement>
                                <Input type="text" className="font-poppins text_regular text_md" placeholder="Search by Job-Profile...." maxW="500px" />
                            </InputGroup>
                            <CustomButton title="Add New Job Skills" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewJobSkills} />
                        </Flex>
                    </Flex>
                    <Grid className="grid_container">
                        <GridItem colSpan={12}>
                            <CustomTable value={skills} >
                                <Column header="S. No" body={(_, index) => index + 1} />
                                <Column header="Department Name" field="departmentName" />
                                <Column header="Job Profile Name" field="jobProfileName" />
                                <Column
                                    header="Skills"
                                    body={(row: any) => (
                                        <Box maxW="250px" overflowY="auto" maxH="60px">
                                            {row.skills?.map((skill: string, sIdx: number) => (
                                                <Tag
                                                    key={sIdx}
                                                    mr={2}
                                                    mb={1}
                                                    size="sm"
                                                    borderRadius="full"
                                                    colorScheme={sIdx % 2 === 0 ? "blue" : "green"}
                                                >
                                                    {skill}
                                                </Tag>
                                            ))}
                                        </Box>
                                    )}
                                />

                                <Column
                                    header="Actions"
                                    body={(row: any) => (<ActionEditIcon onClick={() => handleEditJobProfile(row)} />
                                    )}
                                />
                            </CustomTable>

                        </GridItem>
                    </Grid>

                    <Drawer isOpen={DrawerOpen} placement="right" onClose={closeDrawer} size="md">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px"> {isEditMode ? "Edit Job skills" : "Add New Job skills"}</DrawerHeader>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <DrawerBody>
                                    <Flex gap={8} mt={2}>
                                        <Controller name="department_Id" control={control}
                                            render={({ field }) => (
                                                <Dropdown {...field} control={control} label="Department" errors={errors} options={departmentOptions} valueKey="id" labelKey="departmentName" />
                                            )}
                                        />
                                        <Controller name="job_Profile_Id" control={control}
                                            render={({ field }) => (
                                                <Dropdown {...field} control={control} label="Job Title" errors={errors} options={jobProfileOptions} valueKey="id" labelKey="job_Profile" />
                                            )}
                                        />
                                    </Flex>

                                    <Flex gap={2} mt={4} wrap="wrap">
                                        {chips.map((chip) => (
                                            <Tag size="md" key={chip} borderRadius="full" variant="solid" colorScheme="blue">
                                                <TagLabel>{chip}</TagLabel>
                                                <TagCloseButton onClick={() => handleRemoveChip(chip)} />
                                            </Tag>
                                        ))}
                                        <Input placeholder="Type Skills and press Enter" value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyDown={handleKeyDown} />
                                    </Flex>
                                    {errors.skills && (
                                        <Text color="red.500" fontSize="sm" mt={1}>
                                            {errors.skills.message?.toString()}
                                        </Text>
                                    )}

                                </DrawerBody>

                                <DrawerFooter>
                                    <Button variant="outline" mr={3} onClick={closeDrawer} > Cancel</Button>
                                    <Button type="submit" bg="#006838" color="white" _hover={{ bg: "#00512a" }} > {isEditMode ? "Update Job skills" : "Add New Job skills"} </Button>
                                </DrawerFooter>
                            </form>
                        </DrawerContent>
                    </Drawer>
                </>
            </Box>
        </MyDiv>
    );
};

export default JobSkills;


